import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-wrap gap-4 md:flex-row md:items-center md:justify-between',
    title: 'heading-3xl max-md:heading-m-bold order-0 !font-[450]',
    info: 'heading-xs order-4 flex w-full items-center gap-2 xl:order-3 xl:w-fit',
    infoText: 'whitespace-pre',
    infoUnavailable: 'text-label-red whitespace-pre',
    actionButton:
      'text-secondary-hover link heading-xs-intr order-2 font-[450] tracking-[0.06em] whitespace-pre uppercase max-md:mt-0.5 max-md:text-[12px] md:order-3 md:mt-4 md:ml-auto',
    label:
      'flex-center px-3 py-4 font-[450] max-md:order-3 max-md:-mt-2 max-md:py-0'
  },
  variants: {},
  defaultVariants: {}
});
